import React, { useState, useEffect } from 'react'
import { Container, TextField, Button, Typography, Box } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from 'axios'
import { addData, clearTable } from '../api/indexedDBHandler'
import { useDispatch } from 'react-redux'
import { loginSuccess } from '../slices/authSlice'
const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [step, setStep] = useState(1) // Шаг 1: ввод номера, Шаг 2: ввод кода
  const [timer, setTimer] = useState(0) // Таймер для повторной отправки кода
  const [isDisabled, setDisabled] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1)
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [timer])

  const handleSendCode = async () => {
    if (!phoneNumber) {
      setError('Пожалуйста, введите номер телефона.')
      return
    }
    setError('')
    setDisabled(true)
    try {
      const response = await axios.post(
        'https://admin-protocarp.ru/php/login.php',
        {
          phoneNumber,
        }
      )
      if (response.data.success) {
        localStorage.setItem('token', JSON.stringify(response.data.token))
        localStorage.setItem('uuid', JSON.stringify(response.data.uuid))

        setStep(2)
        setTimer(60) // Таймер на 60 секунд
      } else {
        setError(response.data.message || 'Ошибка отправки кода.')
      }
    } catch (err) {
      setError('Произошла ошибка. Попробуйте снова.')
    }
  }

  const handleVerifyCode = async () => {
    if (!code) {
      setError('Пожалуйста, введите код.')
      return
    }
    setError('')
    const deviceInfo = collectDeviceInfo()
    try {
      const token = JSON.parse(localStorage.getItem('token'))
      const uuid = JSON.parse(localStorage.getItem('uuid'))
      const response = await axios.post(
        'https://admin-protocarp.ru/php/verify.php',
        {
          phoneNumber,
          code,
          uuid,
          token,
          device_info: deviceInfo,
        }
      )
      if (response.data.success) {
        await clearTable('user')
        await addData('user', { ...response.data.user })
        localStorage.setItem(
          'sessionToken',
          JSON.stringify(response.data.user.token)
        )
        dispatch(loginSuccess(true))
        window.location.href = '/'
      } else {
        setError(response.data.message || 'Неверный код.')
      }
    } catch (err) {
      setError('Произошла ошибка. Попробуйте снова.')
    }
  }
  function collectDeviceInfo() {
    const screenWidth = window.screen.width
    const screenHeight = window.screen.height

    // Дополнительная информация о браузере и ОС
    const userAgent = navigator.userAgent
    const platform = navigator.platform

    return {
      screen_width: screenWidth,
      screen_height: screenHeight,
      user_agent: userAgent,
      platform: platform,
      // Дополнительные данные, которые можно собрать на клиенте
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
      cookies_enabled: navigator.cookieEnabled,
      hardware_concurrency: navigator.hardwareConcurrency || 'unknown',
    }
  }
  return (
    <Container maxWidth="sm">
      <Box mt={5} display="flex" flexDirection="column" alignItems="center">
        <img
          src="/images/logo.png"
          style={{ maxWidth: '30%', borderRadius: '10px' }}
          alt="logo"
        />
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          style={{ paddingTop: '70px' }}
        >
          Авторизация
        </Typography>
        {step === 1 && (
          <Box>
            <Typography variant="caption" display="block" gutterBottom>
              Мы отправим на номер SMS-сообщение с кодом подтверждения.
            </Typography>
            <PhoneInput
              country={'ru'}
              value={phoneNumber}
              onChange={(value) => setPhoneNumber(value)}
              inputStyle={{ width: '100%', marginTop: '10px' }}
              placeholder="Введите номер телефона"
            />
            {error && (
              <Typography
                color="error"
                variant="body2"
                style={{ marginTop: '10px' }}
              >
                {error}
              </Typography>
            )}
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                disabled={isDisabled}
                variant="contained"
                color="primary"
                onClick={handleSendCode}
                sx={{
                  borderRadius: '20px',
                  padding: '10px 20px',
                }}
              >
                Получить код
              </Button>
            </Box>
          </Box>
        )}
        {step === 2 && (
          <Box>
            <Typography variant="body2" gutterBottom>
              Мы отправили код на номер {phoneNumber}.
            </Typography>

            <TextField
              label="Введите код"
              variant="outlined"
              margin="normal"
              type="tel"
              fullWidth
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <Typography variant="caption" display="block">
              Повторно отправить код можно через {timer} секунд.
            </Typography>
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="success"
                onClick={handleVerifyCode}
                sx={{
                  borderRadius: '20px',
                  padding: '10px 20px',
                }}
              >
                Подтвердить
              </Button>
            </Box>
            {timer === 0 && (
              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleSendCode}
                  sx={{
                    borderRadius: '20px',
                    padding: '10px 20px',
                  }}
                >
                  Отправить код повторно
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Container>
  )
}
// t9TF3x3
export default Login
